import { StoreOffIcon } from './StoreOffIcon';

/**
 * author: Colton Wiscombe
 * id 93E71904-C645-4682-B4C9-B61124B5C468
 * name store-off
 * version: 6.3.95
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/store-off.svg
 * tags
 * - Places 
 * - Shopping 
 */
export const ShopOffIcon = StoreOffIcon;
export default ShopOffIcon